// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var LlmModel$ReactHooksTemplate = require("./llmModel.res.js");
var LlmProvider$ReactHooksTemplate = require("./llmProvider.res.js");

function LlmProviderForm(props) {
  var toggleModal = props.toggleModal;
  var onFormSubmit = props.onFormSubmit;
  var selectedProvider = props.selectedProvider;
  var match = React.useState(function (param) {
        return selectedProvider;
      });
  var setProvider = match[1];
  var provider = match[0];
  var match$1 = React.useState(function (param) {
        return LlmProvider$ReactHooksTemplate.models(provider);
      });
  var setModels = match$1[1];
  var models = match$1[0];
  React.useState(function (param) {
        
      });
  var match$2 = React.useState(function (param) {
        
      });
  var setConnectionLoading = match$2[1];
  var connectionLoading = match$2[0];
  var match$3 = React.useState(function (param) {
        return {};
      });
  var setConnectionMessages = match$3[1];
  var connectionMessages = match$3[0];
  var handleChange = function (field, value) {
    Curry._1(setProvider, (function (prev) {
            switch (field) {
              case "auth_type" :
                  return LlmProvider$ReactHooksTemplate.setAuthType(prev, value);
              case "endpoint" :
                  return LlmProvider$ReactHooksTemplate.setEndpoint(prev, value);
              case "name" :
                  return LlmProvider$ReactHooksTemplate.setName(prev, value);
              default:
                return prev;
            }
          }));
  };
  var handleAuthConfigChange = function (key, value) {
    Curry._1(setProvider, (function (provider) {
            var oldConfig = LlmProvider$ReactHooksTemplate.authConfig(provider);
            var newConfig = {};
            Belt_Array.forEach(Js_dict.entries(oldConfig), (function (param) {
                    newConfig[param[0]] = param[1];
                  }));
            newConfig[key] = value;
            return LlmProvider$ReactHooksTemplate.setAuthConfig(provider, newConfig);
          }));
    console.log("Auth_config", LlmProvider$ReactHooksTemplate.authConfig(provider));
  };
  var isProviderReady = function (param) {
    var name = LlmProvider$ReactHooksTemplate.name(provider);
    var endpoint = LlmProvider$ReactHooksTemplate.endpoint(provider);
    var authType = LlmProvider$ReactHooksTemplate.authType(provider);
    var authConfig = LlmProvider$ReactHooksTemplate.authConfig(provider);
    switch (authType) {
      case "api_key" :
          if (!(name !== "" && endpoint !== "" && authType !== "")) {
            return false;
          }
          var key = Js_dict.get(authConfig, "api_key");
          if (key !== undefined) {
            return key !== "";
          } else {
            return false;
          }
      case "bearer" :
          if (!(name !== "" && endpoint !== "" && authType !== "")) {
            return false;
          }
          var token = Js_dict.get(authConfig, "token");
          if (token !== undefined) {
            return token !== "";
          } else {
            return false;
          }
      case "no_auth" :
          if (name !== "" && endpoint !== "") {
            return authType !== "";
          } else {
            return false;
          }
      default:
        return false;
    }
  };
  var match$4 = LlmProvider$ReactHooksTemplate.id(provider);
  var match$5 = LlmProvider$ReactHooksTemplate.authType(provider);
  var tmp;
  switch (match$5) {
    case "api_key" :
        var v = Js_dict.get(LlmProvider$ReactHooksTemplate.authConfig(provider), "header_name");
        var v$1 = Js_dict.get(LlmProvider$ReactHooksTemplate.authConfig(provider), "api_key");
        tmp = JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("label", {
                              children: "Header Name",
                              className: "block text-sm font-medium text-gray-700 mb-2"
                            }),
                        JsxRuntime.jsx("input", {
                              className: "w-full border border-gray-300 rounded-lg px-3 py-2",
                              value: v !== undefined ? v : "X-API-Key",
                              onChange: (function (e) {
                                  handleAuthConfigChange("header_name", e.target.value);
                                })
                            })
                      ]
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("label", {
                              children: "Header Value",
                              className: "block text-sm font-medium text-gray-700 mb-2"
                            }),
                        JsxRuntime.jsx("input", {
                              className: "w-full border border-gray-300 rounded-lg px-3 py-2",
                              placeholder: "api_key",
                              type: "text",
                              value: v$1 !== undefined ? v$1 : "",
                              onChange: (function (e) {
                                  handleAuthConfigChange("api_key", e.target.value);
                                })
                            })
                      ]
                    })
              ],
              className: "grid grid-cols-2 gap-4"
            });
        break;
    case "bearer" :
        var v$2 = Js_dict.get(LlmProvider$ReactHooksTemplate.authConfig(provider), "token");
        tmp = JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("label", {
                      children: "Token",
                      className: "block text-sm font-medium text-gray-700 mb-2"
                    }),
                JsxRuntime.jsx("input", {
                      className: "w-full border border-gray-300 rounded-lg px-3 py-2",
                      required: true,
                      type: "text",
                      value: v$2 !== undefined ? v$2 : "",
                      onChange: (function (e) {
                          handleAuthConfigChange("token", e.target.value);
                        })
                    })
              ],
              className: "space-y-2"
            });
        break;
    default:
      tmp = null;
  }
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("button", {
                            children: JsxRuntime.jsx("img", {
                                  className: "h-3 m-2 float-right cursor-pointer",
                                  src: Image$ReactHooksTemplate.closeIcon,
                                  onClick: (function (param) {
                                      Curry._1(toggleModal, undefined);
                                    })
                                }),
                            className: "absolute top-3 right-3 text-gray-400 hover:text-gray-600"
                          }),
                      JsxRuntime.jsx("h2", {
                            children: match$4 !== undefined ? "Edit AI Provider" : "Add AI Provider",
                            className: "text-xl font-semibold mb-6"
                          }),
                      JsxRuntime.jsxs("form", {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("label", {
                                            children: "Provider Name",
                                            className: "block text-sm font-medium text-gray-700 mb-2"
                                          }),
                                      JsxRuntime.jsx("input", {
                                            className: "w-full border border-gray-300 rounded-lg px-3 py-2",
                                            required: true,
                                            value: LlmProvider$ReactHooksTemplate.name(provider),
                                            onChange: (function (e) {
                                                handleChange("name", e.target.value);
                                              })
                                          })
                                    ]
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("label", {
                                            children: "Endpoint URL",
                                            className: "block text-sm font-medium text-gray-700 mb-2"
                                          }),
                                      JsxRuntime.jsx("input", {
                                            className: "w-full border border-gray-300 rounded-lg px-3 py-2",
                                            required: true,
                                            value: LlmProvider$ReactHooksTemplate.endpoint(provider),
                                            onChange: (function (e) {
                                                handleChange("endpoint", e.target.value);
                                              })
                                          })
                                    ]
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("label", {
                                            children: "Auth Type",
                                            className: "block text-sm font-medium text-gray-700 mb-2"
                                          }),
                                      JsxRuntime.jsxs("select", {
                                            children: [
                                              JsxRuntime.jsx("option", {
                                                    children: "Select Auth Type",
                                                    value: ""
                                                  }),
                                              JsxRuntime.jsx("option", {
                                                    children: "No Authentication",
                                                    value: "no_auth"
                                                  }),
                                              JsxRuntime.jsx("option", {
                                                    children: "Bearer Token",
                                                    value: "bearer"
                                                  }),
                                              JsxRuntime.jsx("option", {
                                                    children: "API Key",
                                                    value: "api_key"
                                                  })
                                            ],
                                            className: "w-full border border-gray-300 rounded-lg px-3 py-2",
                                            required: true,
                                            value: LlmProvider$ReactHooksTemplate.authType(provider),
                                            onChange: (function (e) {
                                                handleChange("auth_type", e.target.value);
                                              })
                                          })
                                    ]
                                  }),
                              tmp,
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("label", {
                                            children: "Model Names",
                                            className: "block text-sm font-medium text-gray-700"
                                          }),
                                      $$Array.of_list(Belt_List.mapWithIndex(models, (function (i, m) {
                                                  var match = Js_dict.get(connectionMessages, LlmModel$ReactHooksTemplate.name(m));
                                                  var tmp;
                                                  if (match !== undefined) {
                                                    switch (match[0]) {
                                                      case "error" :
                                                          tmp = JsxRuntime.jsx("p", {
                                                                children: match[1],
                                                                className: "text-red-600 text-sm mt-2"
                                                              });
                                                          break;
                                                      case "success" :
                                                          tmp = JsxRuntime.jsx("p", {
                                                                children: match[1],
                                                                className: "text-green-600 text-sm mt-2"
                                                              });
                                                          break;
                                                      default:
                                                        tmp = null;
                                                    }
                                                  } else {
                                                    tmp = null;
                                                  }
                                                  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                                              children: [
                                                                JsxRuntime.jsxs("div", {
                                                                      children: [
                                                                        JsxRuntime.jsx("input", {
                                                                              className: "flex-1 border border-gray-300 rounded-lg px-3 py-2",
                                                                              placeholder: "e.g. gpt-4-turbo",
                                                                              value: LlmModel$ReactHooksTemplate.name(m),
                                                                              onChange: (function (e) {
                                                                                  var value = e.target.value;
                                                                                  var newModel = List.mapi((function (i$1, m) {
                                                                                          if (i$1 === i) {
                                                                                            return LlmModel$ReactHooksTemplate.setName(m, value);
                                                                                          } else {
                                                                                            return m;
                                                                                          }
                                                                                        }), models);
                                                                                  Curry._1(setModels, (function (param) {
                                                                                          return newModel;
                                                                                        }));
                                                                                })
                                                                            }),
                                                                        JsxRuntime.jsx("button", {
                                                                              children: "Remove",
                                                                              className: "text-red-500 text-sm hover:underline",
                                                                              type: "button",
                                                                              onClick: (function (param) {
                                                                                  Curry._1(setModels, (function (ms) {
                                                                                          return Belt_List.keepWithIndex(ms, (function (param, i$1) {
                                                                                                        return i$1 !== i;
                                                                                                      }));
                                                                                        }));
                                                                                })
                                                                            }),
                                                                        JsxRuntime.jsxs("div", {
                                                                              children: [
                                                                                JsxRuntime.jsx("button", {
                                                                                      children: connectionLoading !== undefined && connectionLoading === LlmModel$ReactHooksTemplate.name(m) ? "Testing..." : "Test Connection",
                                                                                      className: "px-4 py-2 bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-lg hover:from-purple-700 hover:to-blue-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed",
                                                                                      disabled: connectionLoading !== undefined ? connectionLoading === LlmModel$ReactHooksTemplate.name(m) : false,
                                                                                      onClick: (function (param) {
                                                                                          var modelName = LlmModel$ReactHooksTemplate.name(m);
                                                                                          Curry._1(setConnectionLoading, (function (param) {
                                                                                                  return modelName;
                                                                                                }));
                                                                                          var payload = {};
                                                                                          payload["api_endpoint"] = LlmProvider$ReactHooksTemplate.endpoint(provider);
                                                                                          payload["auth_type"] = LlmProvider$ReactHooksTemplate.authType(provider);
                                                                                          payload["model_name"] = modelName;
                                                                                          var authConfig = {};
                                                                                          var match = LlmProvider$ReactHooksTemplate.authType(provider);
                                                                                          switch (match) {
                                                                                            case "api_key" :
                                                                                                var headerName = Belt_Option.getWithDefault(Js_dict.get(LlmProvider$ReactHooksTemplate.authConfig(provider), "header_name"), "X-API-Key");
                                                                                                var apiKey = Belt_Option.getWithDefault(Js_dict.get(LlmProvider$ReactHooksTemplate.authConfig(provider), "api_key"), "");
                                                                                                authConfig["header_name"] = headerName;
                                                                                                authConfig["api_key"] = apiKey;
                                                                                                break;
                                                                                            case "bearer" :
                                                                                                var token = Js_dict.get(LlmProvider$ReactHooksTemplate.authConfig(provider), "token");
                                                                                                if (token !== undefined) {
                                                                                                  authConfig["token"] = token;
                                                                                                }
                                                                                                break;
                                                                                            default:
                                                                                              
                                                                                          }
                                                                                          payload["auth_config"] = authConfig;
                                                                                          var id = LlmProvider$ReactHooksTemplate.id(provider);
                                                                                          var url = id !== undefined ? "/api/v1/llm_providers/" + String(id) + "/test_connection" : "/api/v1/llm_providers/test_connection";
                                                                                          Js_promise.$$catch((function (_err) {
                                                                                                  Curry._1(setConnectionLoading, (function (param) {
                                                                                                          
                                                                                                        }));
                                                                                                  return Promise.resolve();
                                                                                                }), Js_promise.then_((function (response) {
                                                                                                      var status = Json_decode.field("status", (function (param) {
                                                                                                              return Json_decode.withDefault("failed", Json_decode.string, param);
                                                                                                            }), response);
                                                                                                      var message = Json_decode.field("message", (function (param) {
                                                                                                              return Json_decode.withDefault("", Json_decode.string, param);
                                                                                                            }), response);
                                                                                                      if (status === "success") {
                                                                                                        Curry._1(setConnectionMessages, (function (msgs) {
                                                                                                                msgs[modelName] = [
                                                                                                                  "success",
                                                                                                                  message
                                                                                                                ];
                                                                                                                return msgs;
                                                                                                              }));
                                                                                                        Curry._1(setConnectionLoading, (function (param) {
                                                                                                                
                                                                                                              }));
                                                                                                        Curry._1(setModels, (function (ms) {
                                                                                                                return List.map((function (m) {
                                                                                                                              if (LlmModel$ReactHooksTemplate.name(m) === modelName) {
                                                                                                                                return LlmModel$ReactHooksTemplate.setActive(m, true);
                                                                                                                              } else {
                                                                                                                                return m;
                                                                                                                              }
                                                                                                                            }), ms);
                                                                                                              }));
                                                                                                        return Promise.resolve();
                                                                                                      }
                                                                                                      Curry._1(setConnectionMessages, (function (msgs) {
                                                                                                              msgs[modelName] = [
                                                                                                                "error",
                                                                                                                message
                                                                                                              ];
                                                                                                              return msgs;
                                                                                                            }));
                                                                                                      Curry._1(setConnectionLoading, (function (param) {
                                                                                                              
                                                                                                            }));
                                                                                                      Curry._1(setModels, (function (ms) {
                                                                                                              return List.map((function (m) {
                                                                                                                            if (LlmModel$ReactHooksTemplate.name(m) === modelName) {
                                                                                                                              return LlmModel$ReactHooksTemplate.setActive(m, false);
                                                                                                                            } else {
                                                                                                                              return m;
                                                                                                                            }
                                                                                                                          }), ms);
                                                                                                            }));
                                                                                                      return Promise.resolve();
                                                                                                    }), Http$ReactHooksTemplate.fetchPostJSON(url, payload)));
                                                                                        })
                                                                                    }),
                                                                                LlmModel$ReactHooksTemplate.active(m) ? JsxRuntime.jsx("span", {
                                                                                        children: "✓ Enabled",
                                                                                        className: "text-green-600 text-sm font-medium ml-2"
                                                                                      }) : JsxRuntime.jsx("span", {
                                                                                        children: "Not Active",
                                                                                        className: "text-gray-400 text-sm ml-2"
                                                                                      })
                                                                              ],
                                                                              className: "flex items-center justify-between"
                                                                            })
                                                                      ],
                                                                      className: "flex items-center space-x-3"
                                                                    }, String(i)),
                                                                JsxRuntime.jsx("div", {
                                                                      children: JsxRuntime.jsx("div", {
                                                                            children: tmp
                                                                          })
                                                                    })
                                                              ]
                                                            });
                                                }))),
                                      JsxRuntime.jsx("button", {
                                            children: "+ Add Model",
                                            className: "px-3 py-1 text-sm rounded-lg border transition-all duration-200 " + (
                                              isProviderReady() ? "text-blue-600 bg-blue-50 border-blue-200 hover:bg-blue-100" : "text-gray-400 bg-gray-100 border-gray-200 cursor-not-allowed"
                                            ),
                                            disabled: !isProviderReady(),
                                            type: "button",
                                            onClick: (function (param) {
                                                Curry._1(setModels, (function (ms) {
                                                        return List.append(ms, {
                                                                    hd: LlmModel$ReactHooksTemplate.emptyModel(),
                                                                    tl: /* [] */0
                                                                  });
                                                      }));
                                              })
                                          })
                                    ],
                                    className: "space-y-3"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("button", {
                                            children: "Cancel",
                                            className: "px-4 py-2 text-sm text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50",
                                            type: "button",
                                            onClick: (function (param) {
                                                Curry._1(toggleModal, undefined);
                                              })
                                          }),
                                      JsxRuntime.jsx("button", {
                                            children: "Save Provider",
                                            className: "px-6 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700",
                                            type: "submit"
                                          })
                                    ],
                                    className: "pt-4 flex justify-end space-x-3 border-t border-gray-200"
                                  })
                            ],
                            className: "space-y-5",
                            onSubmit: (function (e) {
                                e.preventDefault();
                                Curry._1(onFormSubmit, LlmProvider$ReactHooksTemplate.setModels(provider, models));
                              })
                          })
                    ],
                    className: "bg-white rounded-xl shadow-lg w-full max-w-2xl p-6 relative overflow-y-auto max-h-[90vh]"
                  }),
              className: "fixed inset-0 z-50 flex items-center justify-center bg-black/30"
            });
}

var make = LlmProviderForm;

exports.make = make;
/* react Not a pure module */
